import { Component } from '@angular/core';

@Component({
    selector: 'grt-about-content',
    templateUrl: './about-content.component.html',
    styleUrls: ['./about-content.component.scss']
})
export class AboutContentComponent {
}
